import { observer } from "mobx-react";
import React, { useEffect } from "react";

import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { AccountStatementWalletFilter } from "@features/account-statement/desktop/filter";
import AccountStatementOnlineUserShopDropdown from "@features/account-statement/desktop/filter/components/AccountStatementOnlineUserShopDropdown";
import { AccountStatementPeriodDropdown } from "@features/account-statement/desktop/filter/components/AccountStatementPeriodDropdown";
import AccountStatementShopUserShopDropdown from "@features/account-statement/desktop/filter/components/AccountStatementShopUserShopDropdown";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";

import { AccountStatementTransactionDropdown } from "./components/AccountStatementTransactionDropdown";

export default observer(function AccountStatementFilter() {
	const store = useAccountStatementStore();

	const t = useTranslation().t;
	const form = useForm({
		mode: "onSubmit",
		defaultValues: store.statementFilter || {},
	});

	useEffect(() => {
		if (store.statementFilter) {
			form.reset(store.statementFilter);
		}
	}, [store.statementFilter, store.transactionLookup]);

	return (
		<FormProvider {...form}>
			<form
				onSubmit={form.handleSubmit(store.onFilterSubmit)}
				className="form"
				data-at="at-AccountStatementFilter"
			>
				<div className="card--primary card--shadowy">
					<div className="card--primary__header">
						<div className="card--primary__title title--primary u-mar--right--xsml">
							{t<string>("ACC_STATEMENT.FILTER.AS_HEAD")}
						</div>
					</div>
					<div className="card--primary__body">
						<AccountStatementOnlineUserShopDropdown />
						<AccountStatementShopUserShopDropdown />
						<AccountStatementWalletFilter />
						<AccountStatementPeriodDropdown />

						<AccountStatementTransactionDropdown />
					</div>
					<div className="card--primary__footer">
						<Button
							btnText={t("ACC_STATEMENT.FILTER.AS_BUTTON")}
							className="btn--base btn--accent"
							atClassName="at-AccountStatementFilter__btn--primary"
						/>
					</div>
				</div>
			</form>
		</FormProvider>
	);
});
